import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'isSvg',
  standalone: false,
})
export class IsSvgPipe implements PipeTransform {
  transform(value: string): boolean {
    const splitByDotExtension = value.split('.').pop();

    return splitByDotExtension ? splitByDotExtension.includes('svg') : false;
  }
}
